import {Column, Lookup} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {IntegrityGrid} from '../../../components';
import useIntegrityContent from '../hooks/useIntegrityContent';
import {lookupType} from './ContentGrid';

const ContentGrid = (props) => {
  const loadContent = useIntegrityContent(props.data.key);

  return (
    <IntegrityGrid
      dataSource={loadContent}
      id={['iD_Content']}
      allowIntegrity={false}
      allowActions={false}
      height={'30vh'}
    >
      <Column caption={i18n2._('#Contenido')} dataField="iD_Content" />
      <Column caption={i18n2._('Tipo')} dataField="type">
        <Lookup dataSource={lookupType} valueExpr="id" displayExpr="name" />
      </Column>
      <Column caption={i18n2._('Título')} dataField="title" />
      <Column caption={i18n2._('Descripción')} dataField="description" />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        hidingPriority={3}
        dataField="updateDate"
        defaultSortOrder={'desc'}
      />
      <Column
        caption={i18n2._('Actualizado por')}
        hidingPriority={4}
        dataField="updatedBy"
      />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityGrid>
  );
};

export default ContentGrid;
